@if (!isOldJwtLink) {
  <div class="invalid-link-wrapper">
    <svg-icon src="plant" preserveAspectRatio="none" [stretch]="true"></svg-icon>
    <div class="invalid-link-header">{{ buildTranslationKey(invalidLinkHeader) | translate }}</div>
    <div class="invalid-link-description">{{ buildTranslationKey(invalidLinkDescription) | translate }}</div>
  </div>
} @else {
  <div class="invalid-link-wrapper">
    <svg-icon src="status_error" class="h-48 w-48" preserveAspectRatio="none" [stretch]="true"></svg-icon>
    <div class="invalid-link-header">{{ buildTranslationKey('oldExternalLinkError') | translate }}</div>
    <div class="invalid-link-description">{{ buildTranslationKey('oldExternalLinkErrorSub') | translate }}</div>
  </div>
}
